import { jsx, jsxs } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import { Footer } from "../Footer.js";
import { Actions } from "./components/Actions.js";
import { HexInput } from "./components/HexInput/HexInput.js";
import { Hue } from "./components/Hue/Hue.js";
import { Saturation } from "./components/Saturation/Saturation.js";
import { usePicker } from "./hooks/usePicker/usePicker.js";
function Picker(props) {
  const { onCancel, onCommit } = props;
  const { saturation, hue } = usePicker(props);
  return /* @__PURE__ */ jsxs(Stack, { gap: 2, padding: 0.25, children: [
    /* @__PURE__ */ jsx(Actions, {}),
    /* @__PURE__ */ jsx(
      Saturation,
      {
        cursor: saturation.cursor,
        onChange: saturation.onMoveSaturation,
        ref: saturation.ref,
        style: saturation.styles
      }
    ),
    /* @__PURE__ */ jsx(Hue, { cursor: hue.cursor, onChange: hue.onMoveHue, ref: hue.ref, style: hue.styles }),
    /* @__PURE__ */ jsx(HexInput, {}),
    /* @__PURE__ */ jsx(Footer, { onCancel, onCommit })
  ] });
}
export {
  Picker
};
//# sourceMappingURL=Picker.js.map
